import React, { forwardRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { RiArrowDropDownLine, RiCloseFill, RiMenuLine } from "react-icons/ri";
import navigationItems from "../../utils/constants/NavigationItems";
import {
  useGetClinicDetails,
  useGetProfileStatus,
  useGetProviderDetails,
} from "../../hooks/useProvider";
import "./Headers.scss";
import withClickOutSideMobile from "./withClickOutSideMobile";
import MainMenu from "./MainMenu";
import SidebarMenu from "./SidebarMenu";
import { useLogout } from "../../hooks/useLogout";
import OTPVerificationContainer from "../otpVerification/OTPVerificationContainer";
import MainMenuVideo from "./MainMenuVideo";
const ProviderMobileMenu = forwardRef(({ open, setOpen }, ref) => {
  const [sideOpen, setSideOpen] = useState(false);
  const { data: providerData } = useGetProviderDetails(
    localStorage.getItem("userID") ? localStorage.getItem("userID") : ""
  );
  const { data: profileCompletionData } = useGetProfileStatus(
    localStorage.getItem("userID")
  );
  //const { refetch, data: logoutData } = useLogout();
  const { mutateAsync: logoutMutate } = useLogout();
  const { data: clinicData } = useGetClinicDetails(
    providerData?.provider?.providerId
  );
  useEffect(() => {
    if (clinicData?.status === "SUCCESS" && clinicData?.clinicProvider) {
      localStorage?.setItem(
        "clinicId",
        clinicData?.clinicProvider[0]?.clinicId
      );
    }
  }, [clinicData]);

  const useAuth = () => {
    const user = localStorage.getItem("userID");
    if (user) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (providerData?.status === "SUCCESS") {
      localStorage.setItem("providerId", providerData?.provider?.providerId);
      localStorage.setItem("providerUn", providerData?.provider?.userName);
      localStorage.setItem(
        "isSCAdmin",
        providerData?.provider?.secondOpinionAdmin
      );
    }
  }, [providerData]);
  const user = useAuth();
  const location = useLocation();
  const navigation = useNavigate();

  const logout = async () => {
     try {
   const response =  await logoutMutate();

    if (response?.status === "SUCCESS") {
      localStorage.removeItem("auth");
    }

    localStorage.removeItem("userID");
    localStorage.removeItem("providerId");
    localStorage.removeItem("clinicId");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("isSCAdmin");
    localStorage.removeItem("refresh_token");

    if (providerData?.provider?.isWebAiSignUp === true) {
      navigation("/login?meragoai=true");
    } else {
      navigation("/login");
    }

    setOpen(false);
  } catch (err) {
    console.error("Logout failed", err);
  }

  };
  const handleMainNavClick = () => {
    setOpen(!open);
  };
  useEffect(() => {
    if (open === false) {
      setSideOpen(false);
    }
  }, [open]);
  return (
    <>
      {user && (
        <div className="navbar" ref={ref}>
          <div className="navbar__left">
            <div className="navbar__logo">
              <img
                src="https://static.meragoapp.com/images/menuLogo.png"
                alt="logo"
                width="55px"
                height="55px"
              />
            </div>
          </div>

          <div className="mobile__hamburger" onClick={handleMainNavClick}>
            {!open ? <RiMenuLine /> : <RiCloseFill />}
          </div>
          {open && (
            <div className="mobile__main__menu">
              <div className="main__menu" onClick={() => setOpen(false)}>
                {providerData?.provider?.providerVerificationStatus ===
                "VERIFIED_AND_APPROVED" ? (
                  <MainMenu
                    providerData={providerData?.provider}
                    clinicData={clinicData}
                  />
                ) : (
                  <MainMenuVideo
                    providerData={providerData?.provider}
                    clinicData={clinicData}
                    profileCompletionData={profileCompletionData}
                  />
                )}
              </div>
              <div
                className="mobile__name__side"
                onClick={() => setSideOpen(!sideOpen)}
              >
                <p>
                  {providerData?.provider?.person.salutation?.salutation} &nbsp;{" "}
                  {providerData?.provider?.person?.name}
                </p>
                <RiArrowDropDownLine />
              </div>
            </div>
          )}
          {sideOpen ? (
             <div className={`sidebar__conatiner ${
      providerData?.provider?.providerVerificationStatus ===
                "VERIFIED_AND_APPROVED" ? "" : "mt-10"
    }`}>
              {/* 
              {!providerData?.provider?.isScribeEnabled && (
                <SidebarMenu
                  setOpen={setOpen}
                  open={open}
                  providerData={providerData?.provider}
                  clinicData={clinicData}
                  profileCompletionData={profileCompletionData}
                />
              )} */}

             
                <SidebarMenu
                  setOpen={setOpen}
                  open={open}
                  providerData={providerData?.provider}
                  clinicData={clinicData}
                  profileCompletionData={profileCompletionData}
                />
              

              {location.pathname !== "/login" && (
                <button onClick={logout}>Logout</button>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {!user && (
        <div className="navbar__login__screen">
          <div className="navbar__logo">
            <img
              src="https://storage.merago.com/clinic/images/mhlogoTrans.png"
              alt="logo"
              width="155px"
              height="45px"
            />
          </div>
          {!location?.pathname?.includes("guest") && (
            <div className="navbar__single">
              {/* {navigationItems.loginMenu.map((items) => (
                <Link
                  key={items.text}
                  to={items.to}
                  className={
                    location.pathname.includes(items.to) ? "navbar_active" : ""
                  }
                >
                  {items.name}
                </Link>
              ))} */}
            </div>
          )}
        </div>
      )}
      {providerData?.provider?.providerVerificationStatus ===
        "VERIFIED_AND_APPROVED" &&
        profileCompletionData?.serviceInfo === true &&
        !providerData?.provider?.mobileConfirmed && (
          <OTPVerificationContainer />
        )}
    </>
  );
});

export default withClickOutSideMobile(ProviderMobileMenu);
